import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'

import { ar } from 'vuetify/locale'
import 'vuetify/styles'
import '@mdi/font/css/materialdesignicons.css'
import '@fortawesome/fontawesome-free/css/all.css'

export default createVuetify({
  components,
  directives,
 
  locale: {
    locale: 'ar',
    fallback: 'ar',
    messages: { ar }
  },
  theme: {
    themes: {
      light: {
        dark: false,
        colors: {
          primary: '#575D90',
          'primary-darken-1': '#4B5080',
          'primary-darken-2': '#3E4266',
          'primary-darken-3': '#32354F',
          secondary: '#7780b4',
          accent: '#3e4266',
        }
      }
    }
  },
  rtl: true
}) 